/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Allday1Inputs */

const en_allday1 = /** @type {(inputs: Allday1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All day`)
};

const de_allday1 = /** @type {(inputs: Allday1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganztägig`)
};

/**
* | output |
* | --- |
* | "All day" |
*
* @param {Allday1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const allday1 = /** @type {((inputs?: Allday1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Allday1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_allday1(inputs)
	return de_allday1(inputs)
});
export { allday1 as "allDay" }